import { useFormContext } from 'react-hook-form';
import React from 'react';
import { DateRangeDropdownV2, SearchFieldV2 as SearchField, FormFieldV2 as FormField } from '@/components/custom/erp';
import { accountSearchColumns } from './cols-definition';
import { Label } from '@/components/ui/label';
import { QUERY_KEYS } from '@/constants';

const BasicInfo: React.FC = () => {
  const { setValue } = useFormContext();

  return (
    <div className='space-y-2 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày báo cáo:</Label>
          <div>
            <FormField name='ngay_bc' type='date' className='w-[206px]' />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40'>Ngày tính hạn tt:</Label>
          <div>
            <FormField name='ngay_tt' type='date' className='w-[206px]' />
          </div>
        </div>
        <div className='flex w-[82.5%] items-center'>
          <Label className='w-40 min-w-40'>Ngày hóa đơn từ/đến:</Label>
          <div>
            <DateRangeDropdownV2 fromDateName='ngay_ct1' toDateName='ngay_ct2' />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Tài khoản:</Label>
          <div className='w-3/4'>
            <SearchField
              type='text'
              searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}/`}
              searchColumns={accountSearchColumns}
              dialogTitle='Tài khoản'
              columnDisplay='code'
              displayRelatedField='name'
              onValueChange={value => {
                setValue('tk', value);
              }}
              classNameRelatedField='w-auto min-w-[300px] max-w-full'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicInfo;
